import { Component } from "react";
import Select from 'react-select';

import AppContext from "../../app-context";

import Popup from "../../popup/popup";

import "./filter-popup.css";

class QueryFilterPopup extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    let filters = (props.filterQuery || '')
      .split(',').reduce((a, f) => {
        let e = f.split(/==|@=\*/);
        let k = e[0];
        let v = e[1];
        let isBool = v === 'true' || v === 'false';

        a[k] = isBool ? JSON.parse(v) : v;
        return a;
      }, {});

    this.state = {
      ...filters,
    };
  }

  getMapping() {
    return {
      Active: {
        label: this.context.translate('general_active'),
        options: [
          {
            label: this.context.translate('general_yes'),
            value: true
          },
          {
            label: this.context.translate('general_no'),
            value: false
          }
        ]
      },
      ...this.props.mapping,
    };
  }

  onInputChange(e) {
    let key = e.target.name;
    let val = e.target.value;

    this.setState({
      [key]: typeof val === 'boolean' ? val : (val || null),
    });
  }

  saveFilter() {
    let filterQuery = Object.entries(this.getMapping())
      .filter(([k, map]) => map)
      .map(([k, map]) => {
        let op = map.options
          ? '=='
          : '@=*';
        let val = this.state[k];

        if (typeof val !== 'boolean' && (!val || val.trim() === '')) {
          return null;
        }

        return `${k}${op}${val}`;
      })
      .filter(f => f);

    this.props.updateFilterQuery(filterQuery.join(','));
    this.props.onDismiss();
  }

  clearFilter() {
    this.props.updateFilterQuery('');
    this.props.onDismiss();
  }

  renderFilter(k, map) {
    if (map.options) {
      return <Select
        className="reactSelect"
        name={k}
        value={map.options.find(o => o.value === this.state[k])}
        options={map.options}
        onChange={(o) => this.onInputChange({ target: { name: k, value: o.value } })}
      />;
    }
    else {
      return <input
        name={k}
        value={this.state[k]}
        onChange={this.onInputChange.bind(this)}
      ></input>
    }

  }

  renderFilters() {
    return Object.entries(this.getMapping())
      .map(([k, map]) => {
        return map && <div className="popup-column">
          <div className="popup-inputContainer">
            <h2>{map.label}</h2>
            {this.renderFilter(k, map)}
          </div>
        </div>;
      });
  }

  render() {
    let tl = this.context.translate;
    return (
      <Popup
        title={tl('general_filter')}
        actions={[
          {
            label: tl('general_delete'),
            handler: this.clearFilter.bind(this),
          },
          {
            label: tl('general_filter'),
            handler: this.saveFilter.bind(this),
            submit: true,
          },
        ]}
        onDismiss={this.props.onDismiss}
      >
        <div className="filterPopup">
          <div className="popup-section">
            {this.renderFilters()}
          </div>
        </div>
      </Popup>
    );
  }
}

export default QueryFilterPopup;
